import { formatMoney as shopifyFormatMoney } from '@shopify/theme-currency'
const settings = window.GM_STATE
const customBadgeTags = settings?.customs?.badge.tags || []
const customBadgeItems = settings?.customs?.badge.items || []

const formatMoney = function (cents, format = settings.shopify.moneyFormat) {
  return shopifyFormatMoney(cents, format)
}

const getSaveMoney = function (price, originalPrice) {
  if (price && originalPrice !== 0) {
    return `${Math.round((price - originalPrice) / price * 100)}%`
  }

  return ''
}

const getProductTitle = (title) => {
  return title
}

const getProductSubtitle = (title) => {
  const textareaEl = document.createElement('textarea')
  textareaEl.innerHTML = title && title.includes('|') ? title.split(' | ')[1] : ''
  return textareaEl.value
}

const getCustomBadgeClass = (tagName) => {
  let tagClass = ''
  if (['new'].includes(tagName)) {
    tagClass = 'badge'
  }
  return tagClass
}

const getBadges = (tags) => {
  const items = []
  let preorderBadgeAdded = false

  const specialTag = [
    'Stock:Coming Soon',
    'Stock:Back In Stock',
    'Stock:Pre-order'
  ]

  if (tags.length) {
    let productTags = tags
    const foundSpecialTag = specialTag.find(tag => productTags.includes(tag))
    if (foundSpecialTag) {
      productTags = [foundSpecialTag.replace('Stock', 'Badge')]
    } else {
      if (productTags.includes('Badge:Sale') && productTags.includes('Badge:Outlet')) {
        // if product is using the tag Badge:Outlet' do not show the 'Sale' Badge
        productTags = tags.filter((tag) => tag !== 'Badge:Sale')
      }
      if (productTags.includes('Badge:Sold Out')) {
        // if product is not available, Badge: Sold out should be show
        productTags = ['Badge:Sold Out']
      }
    }
    for (const tag of productTags) {
      const index = customBadgeTags.findIndex((i) => tag === i)
      if (index !== -1) {
        items.push(customBadgeItems[index])
      } else if (tag.includes('Badge:')) {
        const tagName = tag.replace('Badge:', '')
        items.push({
          text: tagName,
          tag,
          customClass: getCustomBadgeClass(tagName),
          backgroundColor: '',
          textColor: ''
        })
      } else {
        // Check for pre-order tags without adding badges immediately
        const tagLower = tag.toLowerCase()
        if (!preorderBadgeAdded && (tagLower === 'stock:preorder' || tagLower === 'preorder' || tagLower === 'stock:pre-order')) {
          preorderBadgeAdded = true
        }
      }
    }
  }

  // Add a pre-order badge after the loop if a pre-order tag was found
  if (preorderBadgeAdded) {
    items.push({
      text: 'Pre-order',
      tag: 'preorder',
      customClass: 'preorder-badge',
      backgroundColor: '',
      textColor: ''
    })
  }

  return items
}

const getPriceSubscription = (planGroups, price) => {
  const planGroup = planGroups?.find(Boolean)
  const sellingPlans = planGroup?.selling_plans
  const priceAdjustments = sellingPlans?.find(Boolean).price_adjustments
  const priceAdjustment = priceAdjustments?.find(Boolean)
  let priceSubscription = price
  if (priceAdjustment?.value > 0) {
    if (priceAdjustment.value_type === 'percentage') {
      priceSubscription = priceSubscription - priceSubscription * priceAdjustment.value / 100
    } else {
      priceSubscription = priceSubscription - priceAdjustment.value
    }
  }
  return priceSubscription
}

const getSubscriptionSave = (planGroups) => {
  const planGroup = planGroups?.find(Boolean)
  const sellingPlans = planGroup?.selling_plans
  const priceAdjustments = sellingPlans?.find(Boolean).price_adjustments
  const priceAdjustment = priceAdjustments?.find(Boolean)
  let subscriptionSave = null
  if (priceAdjustment?.value > 0) {
    if (priceAdjustment.value_type === 'percentage') {
      subscriptionSave = `${priceAdjustment.value}%`
    } else {
      subscriptionSave = `${formatMoney(priceAdjustment.value)}`
    }
  }
  return subscriptionSave && `Subscribe & Save ${subscriptionSave}`
}

const addBadgeSale = (badges, price, originalPrice) => {
  if (price && originalPrice && price < originalPrice) {
    const salePercent = Math.round((originalPrice - price) / originalPrice * 100)
    const text = `${salePercent}% off`
    badges.unshift({
      text,
      tag: 'label-sale',
      customClass: 'badge-card-sale',
      backgroundColor: '',
      textColor: ''
    })
  }
  return badges
}

const formatRangePrice = (values) => values && values.map(item => formatMoney(item * 100)).join(' - ')

const initInstance = (callback, ctx = this) => {
  const isDesignMode = window.Shopify.designMode || false

  return (...args) => {
    callback.apply(ctx, args) // Init instance
    isDesignMode && document.addEventListener('shopify:section:load', () => callback.apply(ctx, args))
  }
}

const getDefaultImage = (img) => {
  return (Array.isArray(img) && img.length === 0) || !img ? GM_STATE.shopify.defaultImage : img
}

const getGraphqlID = (graphqlID) => {
  return graphqlID ? graphqlID.split('/').pop() : ''
}

const sortStock = () => {
  const stockLevels = GM_STATE_STOCK?.stock_levels
  if (!stockLevels || !stockLevels.length) return []

  const sortedStockLevel = stockLevels.sort((first, second) => {
    return first.stockLevel === second.stockLevel
      ? 0
      : first.stockLevel > second.stockLevel
        ? 1
        : -1
  })

  return sortedStockLevel
}

const getQuantityText = (quantity) => {
  if (quantity <= 0) return 'Sold Out'
  const stockLevels = sortStock()
  if (!stockLevels.length) return ''
  const stockLevel = stockLevels.find(item => item.stockLevel >= quantity)
  if (stockLevel) {
    return stockLevel.message
  }

  return ''
}

export {
  formatMoney,
  getProductTitle,
  getProductSubtitle,
  getBadges,
  getCustomBadgeClass,
  getPriceSubscription,
  getSubscriptionSave,
  addBadgeSale,
  formatRangePrice,
  initInstance,
  getDefaultImage,
  getGraphqlID,
  getSaveMoney,
  getQuantityText
}
